import {
  PillList,
  PillListItem,
  Pill,
} from '@virginexperiencedays/components-v2/src/navigation/Pills';

import type { HTMLAttributes } from 'react';
import type { LinkWrapProps } from '@virginexperiencedays/components-v2/src/navigation/LinkWrap';

type PillStackItemProps = Pick<LinkWrapProps, 'href' | 'onClick' | 'isExternal'> & {
  text: string;
};

export type PillStackProps = Omit<HTMLAttributes<HTMLUListElement>, 'onClick'> & {
  items: PillStackItemProps[];
  onClick?: (data: { text: string }) => void;
};

export const PillStack = ({
  className,
  items,
  onClick: onAllItemClick,
  ...rest
}: PillStackProps) => (
  <PillList className={className} {...rest}>
    {items.map(({ href, text, onClick: onItemClick, isExternal }) => {
      const onClick = (e) => {
        onAllItemClick?.({ text });
        onItemClick?.(e);
      };

      return (
        <PillListItem key={text}>
          <Pill href={href} onClick={onClick} isExternal={isExternal}>
            {text}
          </Pill>
        </PillListItem>
      );
    })}
  </PillList>
);
